<div class="search-component">
  <div class="input-with-icon-left">
    <input
      [(ngModel)]="searchString"
      [typeahead]="dataSource$"
      [typeaheadAsync]="true"
      (typeaheadOnSelect)="onSelect($event)"
      [typeaheadWaitMs]="300"
      [typeaheadItemTemplate]="searchItemTemplate"
      (input)="onSearch(search.value)"
      class="form-control"
      placeholder="Search"
      #search
    />
    <div class="input-icon">
      <i class="modus-icon material-icons">search</i>
    </div>
  </div>
</div>

<ng-template #searchItemTemplate let-model="item" let-index="index">
  <app-search-result [resultItem]="model"></app-search-result>
</ng-template>

<div
  *ngIf="isError"
  class="toast toast-dark show fixed-bottom"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  {{ errorMessage }}
  <button
    type="button"
    class="close"
    data-dismiss="alert"
    (click)="isError = false"
  >
    <i class="modus-icon material-icons">close</i>
  </button>
</div>
